/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import SelectQuestion from '../../../components/mobile/speak-doctor/SelectQuestion';
import DateQuestion from '../../../components/mobile/speak-doctor/DateQuestion';
import TextAreaQuestion from '../../../components/mobile/speak-doctor/TextAreaQuestion';
import SliderQuestion from '../../../components/mobile/speak-doctor/SliderQuestion';

const mobilePlanningGetPregnantRoutes = [
  {
    id: '1',
    path: '/speak-doctor/pregnancy/planning-get-pregnant/first-day-last-period',
    component: (props) => <DateQuestion {...props} />,
    props: {
      fieldName: 'LastPeridDate',
      prevRoutePath: '/speak-doctor/pregnancy',
      nextRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/have-visited-gynecologist',
      title: 'speak-doctor:pregnant.currentPregnant.firstDayLastPeriod',
      subtitle: 'speak-doctor:pregnant.currentPregnant.dontKnow',
      isLastQuestion: false,
    },
  },
  {
    id: '2',
    path: '/speak-doctor/pregnancy/planning-get-pregnant/have-visited-gynecologist',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'VisitedGynecologist',
      prevRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/first-day-last-period',
      nextRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/have-you-taking-floc-acid',
      title: 'speak-doctor:pregnant.currentPregnant.haveYouVisitedGynecologist',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Yes',
          label: 'speak-doctor:pregnant.currentPregnant.options3.yes',
        },
        {
          value: 'No',
          label: 'speak-doctor:pregnant.currentPregnant.options3.no',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '3',
    path: '/speak-doctor/pregnancy/planning-get-pregnant/have-you-taking-floc-acid',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'TakingFolicAcid',
      prevRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/have-visited-gynecologist',
      nextRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/how-many-children-have-you-given-birth-previously',
      title: 'speak-doctor:pregnant.currentPregnant.haveYouTakingFolicAcid',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Yes',
          label: 'speak-doctor:pregnant.currentPregnant.options3.yes',
        },
        {
          value: 'No',
          label: 'speak-doctor:pregnant.currentPregnant.options3.no',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '4',
    path: '/speak-doctor/pregnancy/planning-get-pregnant/how-many-children-have-you-given-birth-previously',
    component: (props) => <SliderQuestion {...props} />,
    props: {
      fieldName: 'HowManyChildren',
      prevRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/have-you-taking-floc-acid',
      nextRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/were-birth-natural-or-caesarean',
      title: 'speak-doctor:pregnant.currentPregnant.howManyChildrenHaveYouGiven',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectNumberOfChildren',
      sliderTextValue: 'speak-doctor:covid.question2.yearOld',
      sliderMinValue: 0,
      sliderMaxValue: 30,
      isLastQuestion: false,
      boxWidth: '100%'
    },
  },
  {
    id: '5',
    path: '/speak-doctor/pregnancy/planning-get-pregnant/were-birth-natural-or-caesarean',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'NaturalOrCaesarean',
      prevRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/how-many-children-have-you-given-birth-previously',
      nextRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/use-any-form-of-contraception',
      title: 'speak-doctor:pregnant.currentPregnant.ifHaveGivenBirthWereTheBirth',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Natural Birth',
          label: 'speak-doctor:pregnant.currentPregnant.options5.naturalBirth',
        },
        {
          value: 'Caesarean Birth',
          label: 'speak-doctor:pregnant.currentPregnant.options5.caesarBirth',
        },
        {
          value: 'Both',
          label: 'speak-doctor:pregnant.currentPregnant.options5.both',
        },
        {
          value: 'Not applicable',
          label: 'speak-doctor:pregnant.currentPregnant.options5.notApplicable',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '6',
    path: '/speak-doctor/pregnancy/planning-get-pregnant/use-any-form-of-contraception',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'AnyFormofContraception',
      prevRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/were-birth-natural-or-caesarean',
      nextRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/if-known-what-is-your-blood-type',
      title: 'speak-doctor:pregnant.currentPregnant.doYouCurrentlyUseContraception',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Yes',
          label: 'speak-doctor:pregnant.currentPregnant.options3.yes',
        },
        {
          value: 'No',
          label: 'speak-doctor:pregnant.currentPregnant.options3.no',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '7',
    path: '/speak-doctor/pregnancy/planning-get-pregnant/if-known-what-is-your-blood-type',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'BloodType',
      prevRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/use-any-form-of-contraception',
      nextRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/history-of-miscarriage',
      title: 'speak-doctor:pregnant.currentPregnant.ifKnowBloodType',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'O negative',
          label: 'speak-doctor:pregnant.currentPregnant.options6.oNegative',
        },
        {
          value: 'O positive',
          label: 'speak-doctor:pregnant.currentPregnant.options6.oPositive',
        },
        {
          value: 'A negative',
          label: 'speak-doctor:pregnant.currentPregnant.options6.aNegative',
        },
        {
          value: 'A positive',
          label: 'speak-doctor:pregnant.currentPregnant.options6.aPositive',
        },
        {
          value: 'B negative',
          label: 'speak-doctor:pregnant.currentPregnant.options6.bNegative',
        },
        {
          value: 'B positive',
          label: 'speak-doctor:pregnant.currentPregnant.options6.bPositive',
        },
        {
          value: 'AB negative',
          label: 'speak-doctor:pregnant.currentPregnant.options6.abNegative',
        },
        {
          value: 'AB positive',
          label: 'speak-doctor:pregnant.currentPregnant.options6.abPositive',
        },
        {
          value: 'Unknown',
          label: 'speak-doctor:pregnant.currentPregnant.unknown',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '8',
    path: '/speak-doctor/pregnancy/planning-get-pregnant/history-of-miscarriage',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'MiscarriageHistory',
      prevRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/if-known-what-is-your-blood-type',
      nextRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/history-of-thypoid-fever',
      title: 'speak-doctor:pregnant.currentPregnant.doYouHaveHistoryMiscarriage',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Yes',
          label: 'speak-doctor:pregnant.currentPregnant.options3.yes',
        },
        {
          value: 'No',
          label: 'speak-doctor:pregnant.currentPregnant.options3.no',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '9',
    path: '/speak-doctor/pregnancy/planning-get-pregnant/history-of-thypoid-fever',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'TyphoidFever',
      prevRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/history-of-miscarriage',
      nextRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/when-you-last-visit-doctor',
      title: 'speak-doctor:pregnant.currentPregnant.doYouHaveHistoryTyphoid',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Yes',
          label: 'speak-doctor:pregnant.currentPregnant.options3.yes',
        },
        {
          value: 'No',
          label: 'speak-doctor:pregnant.currentPregnant.options3.no',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '10',
    path: '/speak-doctor/pregnancy/planning-get-pregnant/when-you-last-visit-doctor',
    component: (props) => <DateQuestion {...props} />,
    props: {
      fieldName: 'LastDoctorVisitDate',
      prevRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/history-of-thypoid-fever',
      nextRoutePath: '/speak-doctor/pregnancy/planning-get-pregnant/speak-to-doctor',
      title: 'speak-doctor:pregnant.currentPregnant.whenYouLastVisitDoctor',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectDateBelow',
      isLastQuestion: false
    }
  },
  {
    id: '11',
    path: '/speak-doctor/pregnancy/planning-get-pregnant/speak-to-doctor',
    component: (props) => <TextAreaQuestion {...props} />,
    props: {
      fieldName: 'WhatWouldLikeToSpeakToDoctor',
      prevRoutePath: '/speak-doctor/pregnancy/first-day-last-period',
      nextRoutePath: '',
      title: 'speak-doctor:pregnant.currentPregnant.whatYouLikeSpeakToDoctor',
      subtitle: '',
      isLastQuestion: true,
    },
  },
];

export const getMobilePlanningGetPregnantRoutes = () => mobilePlanningGetPregnantRoutes;
